import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import SearchIcon from '@mui/icons-material/Search';
import * as XLSX from 'xlsx';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { IconButton } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import FeedIcon from '@mui/icons-material/Feed';
import Select from 'react-select'; // Import react-select
import CircularProgress from '@mui/material/CircularProgress';
import CopyrightIcon from '@mui/icons-material/Copyright';

function OtherRepairORReplacement() {
    const [dataBill, setDataBill] = useState([]);
    const [dataItem, setDataItem] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const tableRef = React.createRef();
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const { isAuthenticated, companyId, branchId, permissions, token, logout } = useAuth();
    const [totalamt, setTotalamt] = useState(0);

    const [branchOptions, setBranchOptions] = useState([]);
    const [selectedBranch, setSelectedBranch] = useState(null);
    const [branchName, setBranchName] = useState(0);
    const [selectedBranches, setSelectedBranches] = useState([]); // Use an array for multiple selections

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        fetchTableData();
        fetchCustomerData();
        fetchBranchData();
    }, [isAuthenticated, companyId, branchId, token, logout]);

    const handleBranchSelect = (selectedOptions) => {
        setSelectedBranches(selectedOptions);
        const branchIds = selectedOptions ? selectedOptions.map(option => option.value) : [];
        // You can now use branchIds to filter or send to the API
        setDataItem([]); // Clear the data when branches are changed
    };

    const fetchBranchData = () => {
        fetchData('ReportApi', `/Branch/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                const options = data.map((customer) => ({
                    label: customer.Name,
                    value: customer.Id,
                }));
                setBranchOptions(options);
            })
            .catch((error) => {
                console.error('Error fetching branch data:', error);
            });
    };


    const [totalbills, setTotalbills] = useState(0);
    useEffect(() => {

        let totalamt = 0;
        let billNumbers = new Set();

        dataItem.forEach(item => {
            totalamt += item.Amount;
            billNumbers.add(item.BillNumber); // Collect unique BillNumbers
        });

        setTotalamt(totalamt);
        const totalBills = billNumbers.size;
        setTotalbills(totalBills);
    }, [dataItem]);


    const fetchCustomerData = () => {

    };

    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };

    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        setFromDate(selectedDate);
    };

    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        setToDate(selectedDate);
    };

    const hasReadReportPermission = permissions.includes('Read Reports');
    const [loading, setLoading] = useState(false);

    const fetchTableData = async () => {
        if (hasReadReportPermission) {
            setDataItem([]);
            setLoading(true);
            let branchIds;

            if (selectedBranches.length === 0) {
                branchIds = branchOptions.map(branch => branch.value);
            } else {
                branchIds = selectedBranches.map(branch => branch.value);
            }
            try {
                const branchIdsString = branchIds.join(',');
                const response = await fetchData('OtherReportApi', `/RepairORReplacement/${companyId}/${branchIdsString}/${fromDate}/${toDate}`, token);
                if (response.responseCode === '1111') {
                    setDataItem(response.response_data);
                }
            } catch (error) {
                console.error('Error fetching Daily Sales Summary Details:', error);
            }
            finally {
                setLoading(false); // Hide loading screen
            }
        }
    };

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredDataItem = dataItem.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };

    const handleExportExcel = () => {
        const excelData = [];
        const headerCaption = [`Repair / Replacement Receipt From : ${formatDate(fromDate)} To : ${formatDate(toDate)}`];
        excelData.push(headerCaption);
        const headerRow = ['Branch Name', 'Receipt Date', 'Time', 'Receipt Number', 'Customer Name', 'Phone Number', 'Sales Man', 'Item Description', 'Item Category', 'Amount', 'Remarks', 'Mode Of Payment'];
        excelData.push(headerRow);
        filteredDataItem.forEach((rowData, index) => {
            const dataRow = [];
            dataRow.push(rowData.BranchName, formatDate(rowData.BillDate),
                rowData.BillTime,
                rowData.BillNumber,
                rowData.CustomerName,
                rowData.PhoneNumber,
                rowData.SalesManName,
                rowData.ItemDescription,
                rowData.ItemCategory,
                parseFloat(rowData.Amount.toFixed(2)),                             
                rowData.Remarks,        
                rowData.ModeOfPayment, // Already a number  
            );
            excelData.push(dataRow);
        });
        //, rowData.PGCategoryName
        // Add total row
        const totalRow = ['', 'Total Bills', totalbills, '', '', '', '', '', '', totalamt, '', ''];
        excelData.push(totalRow);
        const ws = XLSX.utils.aoa_to_sheet(excelData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Repair_Replacement Receipt');
        XLSX.writeFile(wb, 'Repair_ReplacementReceipt.xlsx');
    };


    const branchOptionsWithBlank = [{ label: '--Select--', value: 0 }, ...branchOptions];

    return (
        <div className="w-full  mx-auto" style={{ width: '100%', marginTop: '10px' }}>
            <div style={{ width: '100%', marginBottom: '2', display: 'flex', flexWrap: 'nowrap', alignItems: 'center' }}>
                <div className='w-full mb-2 flex' style={{ marginTop: '10px' }}>
                    <h6 className="block uppercase tracking-wide text-black productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black', width: '250px' }}>
                        Repair / Replacement Receipt
                    </h6>
                </div>
                <div className='w-full mb-2 flex' style={{ marginTop: '10px', marginLeft: '10px' }}>
                    {loading && (
                        <div style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            zIndex: 9999
                        }}>
                            <div>
                                <CircularProgress style={{ color: 'white' }} />
                                <span style={{ color: 'white', marginTop: '10px', display: 'block' }}>Loading...</span>
                            </div>
                        </div>
                    )}
                    <Button
                        style={{ color: "black", height: '36px', marginLeft: '10px' }}
                        onClick={fetchTableData}
                        className="linkcolor"
                    >
                        <IconButton onClick={fetchTableData}>
                            <RefreshIcon style={{ color: 'brown' }} />
                        </IconButton>
                        <span style={{ color: 'brown', fontWeight: 'bolder' }}>Refresh</span>
                    </Button>
                    <Button
                        style={{ color: "black", height: '36px', marginLeft: '-10px' }}
                        onClick={handleExportExcel}
                        className="linkcolor"
                    >
                        <IconButton onClick={handleExportExcel}>
                            <FeedIcon style={{ color: 'darkgreen' }} />
                        </IconButton>
                        <span style={{ color: 'darkgreen', fontWeight: 'bolder' }}>Excel</span>
                    </Button>
                    <div style={{ marginBottom: '10px', marginLeft: '20px', display: 'flex', alignItems: 'center' }}>
                        <SearchIcon onClick={toggleSearchInput} style={{ cursor: 'pointer' }} />
                        {showSearchInput && (
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="text"
                                placeholder="Search..."
                                value={searchQuery}
                                onChange={handleSearch}
                                style={{ marginLeft: '10px', width: '275px' }}
                            />
                        )}
                    </div>
                </div>

                <div className="watermark">
                    <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
                </div>
                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '50px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                        FromDate
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={fromDate} onChange={handleFromDateChange}
                        style={{ marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                        ToDate
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={toDate} onChange={handleToDateChange}
                        style={{ marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
                <div style={{ width: '100%', maxWidth: '30%', marginLeft: '10px', paddingRight: '5', marginRight: '10px', marginBottom: '2', flexBasis: 'auto' }}>

                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                        Branch
                        <span style={{ color: 'red' }}>*</span>
                    </label>

                    <Select
                        options={branchOptionsWithBlank}
                        value={selectedBranches}
                        onChange={handleBranchSelect}
                        placeholder="Select a Branch"
                        isMulti
                        style={{ width: '100%', marginTop: '-11px' }}
                    />
                </div>
            </div>

            <div className='w-full mb-5 flex' style={{ maxHeight: '550px', overflowY: 'auto', marginTop: '7px' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#08396B', Width: '2500px' }}>
                            <TableRow sx={{ whiteSpace: 'nowrap' }}>
                                <TableCell sx={{ backgroundColor: '#08396B', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke', textTransform: 'uppercase' }}>STORE</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke' }}>RECEIPT DATE</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke' }}>RECEIPT NO</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke' }}>CUSTOMER NAME</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke' }}>PHONE NUMBER</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke' }}>SALES MAN</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke' }}>ITEM DESCRIPTION</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke' }}>ITEM CATEGORY</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke' }}>AMOUNT</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke' }}>REMARKS</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '7px', color: 'whitesmoke' }}>MODE OF PAYMENT</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody sx={{ backgroundColor: 'whitesmoke' }}>
                            {filteredDataItem.map((data, index) => (
                                <TableRow
                                    key={data.id}
                                    className={data.routeName === 'Total' ? 'highlighted-row' : ''}
                                    sx={{
                                        padding: '7px',
                                        height: '52px',

                                        backgroundColor: data.routeName === 'Total' ? 'teal' : 'transparent',

                                    }}
                                >

                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.BranchName}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{formatDate(data.BillDate)} {data.BillTime}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.BillNumber}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.CustomerName}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.PhoneNumber}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.SalesManName}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.ItemDescription}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.ItemCategory}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '12px' }}>{data.Amount.toFixed(2)}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.Remarks}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>{data.ModeOfPayment}</TableCell>
                                </TableRow>
                            ))}

                            <TableRow
                                className={'highlighted-row'}
                                sx={{
                                    padding: '7px',
                                    height: '40px',

                                    backgroundColor: 'teal',

                                }}
                            >
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '14px' }}>Total Bills</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'center', fontSize: '14px' }}>{totalbills}</TableCell>
                                <TableCell colSpan={6} />
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontWeight: 'bolder', padding: '5px', textAlign: 'right', fontSize: '14px' }}>{totalamt.toFixed(2)}</TableCell>
                                <TableCell colSpan={2} />
                            </TableRow>

                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </div>
    );
}

export default OtherRepairORReplacement;
